import { Button, createStyles, Loader, MantineProvider, Paper, Stack, Text } from "@mantine/core"
import { IconX } from "@tabler/icons-react"
import { useEffect, useState } from "react"
import { Footer } from "./components/Footer"

const useStyles = createStyles((theme) => ({
    paper: {
        backgroundColor: theme.colors.dark[6],
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: 20,
        borderRadius: 12,
        boxShadow: "rgba(0, 0, 0, 0.05) 0px 0.0625rem 0.1875rem, rgba(0, 0, 0, 0.05) 0px 0.625rem 0.9375rem -0.3125rem, rgba(0, 0, 0, 0.04) 0px 0.4375rem 0.4375rem -0.3125rem"
    },
}))

export interface PlayerSettings {
    productIcon: string,
    companyName: string,
    productColor: string,
    doSetup: boolean,
    isPlayerWindow: boolean,
    networkConfigInvalid: boolean
}

export function App() {
    const { classes } = useStyles()

    // Core states
    const [text, setText] = useState<{ color: string, value: string }>()
    const [failed, setFailed] = useState(false)
    const [returnAddress, setReturnAddress] = useState<string | null>()

    // Read from params
    useEffect(() => {
        const params = new URLSearchParams(window.location.search)

        // Set document title
        document.title = "Login | Singularity Designs"

        // Set from params
        let didSetText = false
        if (!text && params.has("value")) {
            didSetText = true
            setText({ value: decodeURIComponent(params.get("value") ?? ""), color: params.get("color") ?? "" })
        }

        // Set failed from params
        let didSetFailed = false
        if (params.has("failed") && !failed) {
            didSetFailed = true
            setFailed(true)
        }

        // Set return address from params
        if (params.has("return-address")) setReturnAddress(params.get("return-address") ? decodeURIComponent(params.get("return-address") ?? "") : null)

        // Missing everything mode
        if (!text && !failed && !didSetFailed && !didSetText) {
            setFailed(true)
            setText({
                value: "Missing required parameters. Please contact support, if you were redirected here.",
                color: "white"
            })
        }
    }, [text, failed])

    return (
        <MantineProvider withGlobalStyles withNormalizeCSS theme={{
            colorScheme: "dark",
            colors: {
                sb: [
                    "#C1C2C5",
                    "#A6A7AB",
                    "#909296",
                    "#5C5F66",
                    "#F7A400",
                    "#2C2E33",
                    "#25262B",
                    "#1A1B1E",
                    "#F7A400",
                    "#C16300"
                ]
            },
            primaryColor: "sb"
        }}>
            <Stack sx={{ height: "100%", width: "100%" }} align="center" justify="center">
                <Paper className={classes.paper}>
                    {
                        !failed ?
                            <Loader />
                        : <IconX size={32}/>
                    }
                    { 
                        text ?
                            <Text mt={20} color={text.color}>{text.value}</Text>
                        : <></>
                    }
                </Paper>
                <Button mt={10} display={returnAddress ? "" : "none"} onClick={() => {
                    if (returnAddress) window.location.href = returnAddress
                }}>Cancel</Button>
            </Stack>
            <Footer />
        </MantineProvider>
    )
}
